const ServiceData = [
  {
    id: 1,
    img_src:
      "https://d3t5ai5vcxyqte.cloudfront.net/media/jtklaazjieqhljbboiyao.svg",
    title: "Root Canal Treatment",
    description: "Let's save the tooth",
  },
  {
    id: 2,
    img_src: "https://d3t5ai5vcxyqte.cloudfront.net/media/xerhpggjxuxmfpsu.svg",
    title: "Teeth Whitening",
    description: "Are you eyeing whiter teeth?",
  },
  {
    id: 3,
    img_src:
      "https://d3t5ai5vcxyqte.cloudfront.net/media/xckdqmsbqpdhzlhvwood.svg",
    title: "Dental Implants",
    description: "Make your implants last a lifetime.",
  },
  {
    id: 4,
    img_src: "https://d3t5ai5vcxyqte.cloudfront.net/media/ztyabpe.svg",
    title: "Dentures",
    description: "Know the right type of denture for you.",
  },
  {
    id: 5,
    img_src:
      "https://d3t5ai5vcxyqte.cloudfront.net/media/pegjpxeakmijzlnklbubfsfun.svg",
    title: "Dental Fillings",
    description: "Repairing the decay with fillings that blend in.",
  },
  {
    id: 6,
    img_src: "https://d3t5ai5vcxyqte.cloudfront.net/media/znrdvnh.svg",
    title: "Orthodontic Treatment/Braces",
    description: "Never be too shy to smile",
  },
  {
    id: 7,
    img_src:
      "	https://d3t5ai5vcxyqte.cloudfront.net/media/trteeoeviitzkuduaj.svg",
    title: "Cosmetic Dentistry",
    description: "Time to flaunt that smile",
  },
  {
    id: 8,
    img_src:
      "	https://d3t5ai5vcxyqte.cloudfront.net/media/rkkaxifntuslufcqwxelgzu.svg",
    title: "Pediatric Dentistry",
    description: "For your child’s dental health",
  },
];

export default ServiceData;
